<div class="flex justify-around">
    <lib-time-picker
        #startTimePicker
        class="w-[172px] h-[130px] flex flex-col items-center"
        [label]="startTimeLabel"
        [formGroup]="getStartTimeFomGroup()"
        [disabled]="startTimeDisabled()"
    />
    <lib-time-picker
        #endTimePicker
        class="w-[172px] h-[130px] flex flex-col items-center"
        [label]="endTimeLabel"
        [formGroup]="getEndTimeFomGroup()"
        [disabled]="endTimeDisabled()"
    />
</div>